import { DesktopSidebar } from "@src/components/modules/Sidebar/DesktopSidebar";
import { MobileSidebar } from "@src/components/modules/Sidebar/MobileSidebar";
import { Page } from "@src/shared/pages";
import React from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.aside`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 40rem) {
    .mobile {
      display: block;
    }

    .desktop {
      display: none;
    }
  }

  @media only screen and (min-width: 40rem) {
    .desktop {
      display: block;
    }

    .mobile {
      display: none;
    }
  }
`;

type PageProps = {
  activePage?: Page | undefined;
  className?: string;
};

export const Sidebar: React.FC<PageProps> = ({ activePage, className }) => {
  return (
    <StyledRoot className={className}>
      <div className="mobile">
        <MobileSidebar activePage={activePage} />
      </div>
      <div className="desktop">
        <DesktopSidebar activePage={activePage} />
      </div>
    </StyledRoot>
  );
};
